<template>
  <v-container fluid grid-list-xl pt-0>
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          :title="pageTitle + (summaryWeeksRange ? (' (' + summaryWeeksRange + ')') : '')"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <div class="card-memo-1 text-white">
            <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
            黃字代表不良率大於1%
          </div>
          <div class="card-memo-2 text-white">
            <v-icon class="text-danger">mdi-checkbox-blank</v-icon>
            紅字代表不良率大於3%
          </div>
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex xs12 lg2>
                  <v-autocomplete
                    v-model="summaryWeeks"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="weekOptions"
                    label="時間"
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex
                  v-if="!routeLocked"
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryProcessType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProcessTypeMenu"
                    label="製程別"
                    :rules="[v => !!v || '請選擇製程別']"
                    outlined
                  />
                </v-flex>
                <v-flex
                  v-if="!routeLocked && summaryProcessType === 'VC'"
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryStage"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryStageMenu"
                    label="Stage（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg3>
                  <v-autocomplete
                    v-model="summaryAsusDeviceIsn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAsusDeviceIsnMenu"
                    label="料號（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex lex-small
                  mt-3
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center>
                  <v-btn class="mx-0 font-weight-light" color="general" @click="doSubmit()">
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>

        <material-card>
          <div class="calendar">
            <div>
              <div>
                <div class="calendar-np">
                  <span>案名/ASUS料號</span>
                </div>
                <div
                  v-for="(week, w) in WeekList"
                  :key="'w'+w"
                  class="calendar-week calendar-week-np">
                  <span>{{ week }}</span>
                </div>
                <div class="calendar-np">
                  <span>小計</span>
                </div>
              </div>
              <div
                v-for="(list, d) in summaryWeeksList"
                :key="'d'+d"
                class="calendar-row calendar-row-np mr-0 ml-0">
                <div>
                  <div class="calendar-day calendar-day-np-np d-flex">
                    <router-link
                      v-if="NPlist[d] && NPlist[d].TotalFailQty > 0"
                      :to="statLink(NPlist[d], DataStatistcStart, DataStatistcEnd)"
                      target="_blank">
                      <v-btn class="black text-light pl-2 pr-2"><v-icon>mdi-clipboard-text-outline</v-icon></v-btn>
                    </router-link>
                    <div
                      :style="'color:'+ (theme === 'dark' ? 'rgba(252,252,252,1)' : 'rgba(33,33,33,1)') + ';line-height: 1rem;display: inline-block;display: table-cell;vertical-align: middle;padding: 0.5rem 0;'"
                      small>{{ NPlist[d].modelName }}<br>{{ NPlist[d].NP }}</div>
                  </div>
                  <div
                    v-for="(fail, dd) in list.date"
                    :key="'dd'+dd"
                    :class="{'calendar-around': fail.around}"
                    class="calendar-day calendar-day-fail calendar-day-np">
                    <a>
                      {{ fail.day }}
                    </a>
                    <div class="calendar-fail cursor">
                      <router-link
                        :to="statLink(NPlist[d], fail.date)"
                        :style="'color:' + (fail.failList.warningColor ? fail.failList.warningColor : theme === 'dark' ? 'rgba(245,245,245,1)' : 'rgba(30,30,30,1)') + '!important;'"
                        target="_blank"
                        small>
                        <span v-if="fail.failList.productionQty > 0 && fail.failList.failRate >= 0">{{ formatFailRate(fail.failList.failRate) }}</span>
                        <br v-if="fail.failList.productionQty > 0 && fail.failList.failRate >= 0">
                        <span v-if="fail.failList.productionQty > 0">{{ fail.failList.productionQty }}pcs</span>
                      </router-link>
                    </div>
                  </div>
                  <div class="calendar-day calendar-day-np-np">
                    <div class="calendar-fail">
                      <div
                        :style="'color:'+ (theme === 'dark' ? 'rgba(252,252,252,1)' : 'rgba(33,33,33,1)') + ';line-height: 3rem;'"
                        small>{{ NPlist[d].TotalFailQty }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="calendar-np">
                  <span>總計</span>
                </div>
                <div
                  v-for="(Qty, q) in DayTotalQtylist"
                  :key="'q'+q"
                  class="calendar-week calendar-week-np pr-1 text-right">
                  <span>{{ Qty }}</span>
                </div>
                <div class="calendar-np text-right">
                  <span>{{ WeeksTotalQty }}</span>
                </div>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>

      <v-flex flex_width_auto xs12>
        <material-card :title="'符合 '+summaryWeeksRange+' 的總合數據'" color="deep-orange">
          <v-data-table
            :headers="headers"
            :items="responseTable"
            :pagination.sync="pagination"
            class="mt-3 elevation-1"
            multi-sort
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text-general text--darken-3" v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.deviceIsn }}</td>
              <td>{{ item.processType }}</td>
              <td class="text-xs-right">{{ item.productionQty }}</td>
              <td class="text-xs-right">{{ item.failQty }}</td>
              <td class="text-xs-right">
                <v-chip :class="item.warningColor" small>{{ formatFailRate(item.failRate) }}</v-chip>
              </td>
              <td>{{ item.vendor }}</td>
              <td>
                <router-link
                  :to="statLink(item, DataStatistcStart, DataStatistcEnd)"
                  target="_blank"
                >
                  <v-btn class="mx-0 font-weight-light small" color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>統計
                  </v-btn>
                </router-link>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import qs from 'qs'
import Loading from '@/assets/img/loading.gif'
export default {
  name: 'CTQThermalPerformanceWeekly',
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      summaryVendor: '',
      summaryAsusDeviceIsn: '',
      summaryProcessType: 'HP',
      summaryStage: '',
      summaryVendorMenu: [],
      summaryProcessTypeMenu: [
        { text: 'HP', value: 'HP' },
        { text: 'VC', value: 'VC' }
      ],
      summaryStageMenu: [
        { text: 'All', value: 'All' },
        { text: 'PL1', value: 'PL1' },
        { text: 'PL2', value: 'PL2' }
      ],
      summaryAsusDeviceIsnMenu: [],
      summaryWeeks: '',
      summaryWeeksRange: '',
      pendingWeekParam: '',
      weekOptions: [],
      weekRangeMap: {},
      WeekList: ['一', '二', '三', '四', '五', '六', '日'],
      summaryWeeksList: [],
      NPlist: [],
      DayTotalQtylist: [0, 0, 0, 0, 0, 0, 0],
      WeeksTotalQty: 0,
      DataStatistcStart: '',
      DataStatistcEnd: '',
      responseTable: [],
      pagination: { rowsPerPage: -1, sortBy: 'date', descending: false },
      headers: [
        { text: '料號', value: 'deviceIsn' },
        { text: '製程別', value: 'processType' },
        { text: '生產數量', value: 'productionQty', align: 'right' },
        { text: '不良數量', value: 'failQty', align: 'right' },
        { text: '不良率', value: 'failRate', align: 'right' },
        { text: '供應商', value: 'vendor' },
        { text: '操作', value: '' }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    routeLocked () {
      return !!(this.$route.meta && this.$route.meta.processType)
    },
    pageTitle () {
      return (this.$route.meta && this.$route.meta.name) || '週 Performance 生產概況'
    },
    pageBasePath () {
      const matched = this.$route.matched || []
      const last = matched[matched.length - 1] || {}
      const parent = matched[matched.length - 2] || {}
      const child = String(last.path || '').split('/')[0]
      return (parent.path || '/ctqThermalPerformance') + '/' + child
    }
  },
  created () {
    this.applyRouteVariant()
  },
  watch: {
    summaryVendor () {
      this.loadPartNo()
    },
    summaryProcessType () {
      if (this.summaryProcessType !== 'VC') {
        this.summaryStage = ''
      }
      this.loadPartNo()
    },
    summaryStage () {
      this.loadPartNo()
    },
    summaryWeeks () {
      this.loadPartNo()
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', this.pageBasePath)
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.searchDate) {
            this.pendingWeekParam = String(this.$route.params.searchDate)
          }
          this.applyRouteFilters()
          this.buildWeekOptions()
          const body = {
            type: 'thermal_module'
          }
          this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                const data = res.data
                this.summaryVendorMenu = [
                  { text: 'All', value: 'All' },
                  ...data.map(item => ({
                    text: item.code,
                    value: item.code
                  }))
                ]
                // if (this.tempFactory !== '') {
                //   this.summaryVendor = this.tempFactory
                // }
              }
            })
          this.$http.get('/api/thermalModule/selectOption/processType').then(res => res.data)
            .then(res => {
              if (res.status === 'success' && res.data && res.data.length) {
                this.summaryProcessTypeMenu = res.data
              }
            })
          this.loadPartNo()
          this.doSubmit()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    applyRouteVariant () {
      const meta = this.$route.meta || {}
      if (meta.processType) this.summaryProcessType = meta.processType
      if (meta.processType === 'VC' && meta.stage) this.summaryStage = meta.stage
      else if (meta.processType === 'HP') this.summaryStage = ''
    },
    applyRouteFilters () {
      const q = this.$route.query || {}
      if (q.vendor) {
        this.summaryVendor = q.vendor
        this.summaryVendorMenu = [{ text: q.vendor, value: q.vendor }]
      }
      if (!this.routeLocked && q.processType) {
        this.summaryProcessType = q.processType
      }
      if (q.deviceIsn) {
        this.summaryAsusDeviceIsn = q.deviceIsn
        this.summaryAsusDeviceIsnMenu = [{ text: q.deviceIsn, value: q.deviceIsn }]
      }
      if (!this.routeLocked && q.stage) {
        this.summaryStage = q.stage
      }
    },
    queryStage () {
      if (this.summaryProcessType !== 'VC') return ''
      if (!this.summaryStage || this.summaryStage === 'All') return ''
      return this.summaryStage
    },
    loadPartNo () {
      const range = this.weekRangeMap[this.summaryWeeks]
      let url = '/api/thermalModule/selectOption/partNo?processType=' + encodeURIComponent(this.summaryProcessType || 'HP')
      if (this.summaryVendor) {
        url += '&vendor=' + encodeURIComponent(this.summaryVendor)
      }
      if (this.queryStage()) {
        url += '&stage=' + encodeURIComponent(this.queryStage())
      }
      if (range && range[0] && range[1]) {
        url += '&queryStartDate=' + encodeURIComponent(range[0])
        url += '&queryEndDate=' + encodeURIComponent(range[1])
      }
      this.$http.get(url).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryAsusDeviceIsnMenu = res.data
          }
        })
    },
    pad (n) {
      return n < 10 ? '0' + n : String(n)
    },
    toMonday (date) {
      const x = new Date(date.getFullYear(), date.getMonth(), date.getDate())
      const dow = x.getDay() || 7
      x.setDate(x.getDate() - (dow - 1))
      return x
    },
    addDays (date, n) {
      const x = new Date(date.getFullYear(), date.getMonth(), date.getDate())
      x.setDate(x.getDate() + n)
      return x
    },
    majorityYear (monday) {
      const counts = {}
      for (let i = 0; i < 7; i++) {
        const y = this.addDays(monday, i).getFullYear()
        counts[y] = (counts[y] || 0) + 1
      }
      let year = monday.getFullYear()
      let max = 0
      Object.keys(counts).forEach((key) => {
        const n = counts[key]
        const y = Number(key)
        if (n > max || (n === max && y > year)) {
          max = n
          year = y
        }
      })
      return year
    },
    buildWeekOptions () {
      const origin = new Date(2026, 0, 1)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const pad = this.pad
      const md = (d) => pad(d.getMonth() + 1) + '/' + pad(d.getDate())
      const ymd = (d) => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())

      let cursor = this.toMonday(origin)
      const seq = {}
      const options = []
      const rangeMap = {}
      while (cursor <= today) {
        const year = this.majorityYear(cursor)
        if (year >= 2026) {
          seq[year] = (seq[year] || 0) + 1
          const ww = seq[year]
          const end = this.addDays(cursor, 6)
          const key = year + '-W' + pad(ww)
          options.push({
            text: year + ' WW' + pad(ww) + ' (' + md(cursor) + '~' + md(end) + ')',
            value: key
          })
          rangeMap[key] = [ymd(cursor), ymd(end)]
        }
        cursor = this.addDays(cursor, 7)
      }
      options.reverse()
      this.weekOptions = options
      this.weekRangeMap = rangeMap

      const matched = this.matchWeekFromParam(this.pendingWeekParam, rangeMap, options)
      const currentMonday = this.toMonday(today)
      const currentYear = this.majorityYear(currentMonday)
      const currentKey = currentYear + '-W' + pad(seq[currentYear] || 1)
      if (matched) {
        this.summaryWeeks = matched
      } else if (!rangeMap[this.summaryWeeks]) {
        this.summaryWeeks = rangeMap[currentKey] ? currentKey : ((options[0] && options[0].value) || '')
      }
    },
    matchWeekFromParam (param, rangeMap, options) {
      const p = String(param || '')
      if (!p) return ''
      if (/^\d{4}-W\d{2}$/.test(p) && rangeMap[p]) {
        return p
      }
      if (/^\d{6}$/.test(p)) {
        const key = p.substr(0, 4) + '-W' + p.substr(4, 2)
        if (rangeMap[key]) return key
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(p)) {
        const hit = (options || []).find((o) => {
          const r = rangeMap[o.value]
          return r && p >= r[0] && p <= r[1]
        })
        if (hit) return hit.value
      }
      return ''
    },
    toDateKey (value) {
      if (value == null || value === '') return ''
      if (Array.isArray(value) && value.length >= 3) {
        const mm = this.pad(value[1])
        const dd = this.pad(value[2])
        return value[0] + '-' + mm + '-' + dd
      }
      return String(value).replace(/\//g, '-').substr(0, 10)
    },
    formatFailRate (rate) {
      const n = Number(rate)
      if (!isFinite(n)) return '0.0%'
      return (n * 100).toFixed(1) + '%'
    },
    emptyDayCell (dateStr, day) {
      return {
        date: dateStr,
        day,
        around: false,
        failList: {
          failRate: '',
          productionQty: 0,
          warningColor: ''
        }
      }
    },
    skuKey (item) {
      return [
        item.deviceIsn || '',
        item.processType || this.summaryProcessType || '',
        item.vendorPk == null ? '' : item.vendorPk
      ].join('|')
    },
    statLink (item, date, daterange) {
      let url = '/ctqThermalPerformance/testDataStatistc?deviceIsn=' + (item.deviceIsn || item.NP) +
        '&modelname=' + item.modelName +
        '&date=' + date +
        '&vendorpk=' + item.vendorPk +
        '&vendor=' + item.vendor +
        '&processType=' + (item.processType || this.summaryProcessType)
      if (daterange) url += '&daterange=' + daterange
      if ((item.processType || this.summaryProcessType) === 'VC') {
        url += '&stage=' + encodeURIComponent(this.summaryStage || 'All')
      }
      return url
    },
    buildWeekCalendar (byDate) {
      const range = this.weekRangeMap[this.summaryWeeks]
      this.DayTotalQtylist = [0, 0, 0, 0, 0, 0, 0]
      this.WeeksTotalQty = 0
      this.NPlist = []
      this.summaryWeeksList = []
      if (!range) {
        return
      }
      this.DataStatistcStart = range[0]
      this.DataStatistcEnd = range[1]
      const start = new Date(range[0] + 'T00:00:00')
      const weekDates = []
      for (let i = 0; i < 7; i++) {
        const d = this.addDays(start, i)
        weekDates.push({
          date: d.getFullYear() + '-' + this.pad(d.getMonth() + 1) + '-' + this.pad(d.getDate()),
          day: d.getDate()
        })
      }

      const skuMap = {}
      const skuOrder = []
      weekDates.forEach((dayInfo, dayIndex) => {
        const rows = byDate[dayInfo.date] || []
        rows.forEach((item) => {
          const key = this.skuKey(item)
          if (!skuMap[key]) {
            skuMap[key] = {
              NP: item.deviceIsn,
              modelName: item.modelName,
              processType: item.processType || this.summaryProcessType,
              vendor: item.vendor,
              vendorPk: item.vendorPk,
              TotalFailQty: 0,
              date: weekDates.map((wd) => this.emptyDayCell(wd.date, wd.day))
            }
            skuOrder.push(key)
          }
          const qty = Number(item.productionQty) || 0
          skuMap[key].date[dayIndex] = {
            date: dayInfo.date,
            day: dayInfo.day,
            around: false,
            failList: {
              failRate: item.failRate,
              productionQty: qty,
              warningColor: item.warningColor || ''
            }
          }
          skuMap[key].TotalFailQty += qty
          this.DayTotalQtylist[dayIndex] += qty
        })
      })

      skuOrder.forEach((key) => {
        const sku = skuMap[key]
        this.NPlist.push({
          NP: sku.NP,
          deviceIsn: sku.NP,
          modelName: sku.modelName,
          processType: sku.processType,
          vendor: sku.vendor,
          vendorPk: sku.vendorPk,
          TotalFailQty: sku.TotalFailQty
        })
        this.summaryWeeksList.push({ date: sku.date })
      })
      this.DayTotalQtylist.forEach((qty) => {
        this.WeeksTotalQty += qty
      })
    },
    doSubmit () {
      this.loadingView = true
      const range = this.weekRangeMap[this.summaryWeeks]
      if (!range) return
      this.summaryWeeksRange = range[0] + ' ~ ' + range[1]
      this.DataStatistcStart = range[0]
      this.DataStatistcEnd = range[1]
      const body = {
        queryStartDate: range[0],
        queryEndDate: range[1],
        vendor: this.summaryVendor === 'All' || !this.summaryVendor ? '' : this.summaryVendor,
        deviceIsn: this.summaryAsusDeviceIsn === 'All' || !this.summaryAsusDeviceIsn ? '' : this.summaryAsusDeviceIsn,
        processType: this.summaryProcessType || 'HP',
        stage: this.queryStage()
      }
      this.$http.post('/api/thermalModule/weeklyFailRateInfo', body).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.responseTable = res.data
          }
        })
      this.$http.post('/api/thermalModule/dailyFailRateInfo', body).then(res => res.data)
        .then(res => {
          const byDate = {}
          if (res.status === 'success' && Array.isArray(res.data)) {
            res.data.forEach((day) => {
              const dateKey = this.toDateKey(day.productionDate || (day.productionData && day.productionData[0] && day.productionData[0].date))
              if (!dateKey) return
              byDate[dateKey] = day.productionData || []
            })
          }
          this.buildWeekCalendar(byDate)
          this.loadingView = false
        })
    }
  }
}
</script>
